import { render, staticRenderFns } from "./sealTouchDetect.vue?vue&type=template&id=9fcffebe&scoped=true"
import script from "./sealTouchDetect.vue?vue&type=script&lang=js"
export * from "./sealTouchDetect.vue?vue&type=script&lang=js"
import style0 from "./sealTouchDetect.vue?vue&type=style&index=0&id=9fcffebe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fcffebe",
  null
  
)

export default component.exports